import React from 'react';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  confirmButtonClass?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = 'تایید',
  cancelText = 'لغو',
  confirmButtonClass = 'bg-red-600 hover:bg-red-700'
}) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-gray-600 bg-opacity-50 z-50 overflow-y-auto"
      onClick={onCancel}
      style={{ direction: 'ltr' }}
    >
      <div className="min-h-full flex items-center justify-center p-4">
        <div 
          className="relative p-6 border w-full max-w-md shadow-lg rounded-md bg-white mx-auto"
          onClick={(e) => e.stopPropagation()}
          style={{ direction: 'rtl' }}
        >
          <h3 className="text-lg font-bold text-gray-900 mb-4">
            {title}
          </h3>
          <p className="text-sm text-gray-700 mb-6">
            {message}
          </p>
          <div className="flex justify-end space-x-3">
            <button
              onClick={onCancel}
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400 transition-colors"
            >
              {cancelText}
            </button>
            <button
              onClick={onConfirm}
              className={`px-4 py-2 text-white rounded-md transition-colors ${confirmButtonClass}`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;

